// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","management":"Footer_management__oH7zr","mgmt":"Footer_mgmt__p3y-O"};